import React from "react";
import { Typography } from "@mui/material";
import { HasClassName } from "@lib/types";
import { makeStyles } from "@providers/Mui";
import clsx from "clsx";

type H5Props = HasClassName & {};

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 22,
    fontWeight: 700,
  },
}));

export const H5: React.FC<H5Props> = ({ children, className }) => {
  const classes = useStyles();
  return (
    <Typography variant="h5" className={clsx(classes.root, className)}>
      {children}
    </Typography>
  );
};
